import React, { useState, useContext } from "react";
import { Button } from "/src/modern/components/ui/button";
import { Card, CardContent } from "/src/modern/components/ui/card";
import { TooltipProvider, } from "/src/modern/components/ui/tooltip";
import { MessageDialog } from "@bryntum/schedulerpro";
import { getDemoBoardsList, duplicateBoardAndTestDrive } from "../../../network/network.jsx";
import { showToast, serverErrorMsg } from "../../../other/utils/utils.jsx";
import BryntumContext from "../../context/bryntumContext.jsx";
import { shouldShowAsyncDialog } from "../../../bryntum-lib/editors/AsyncTaskMessageEditor/SwivuAsyncMessagePopup.jsx";
import { EDITOR_KEYS } from "../../../other/constants/EditorKeys.jsx";

export function TemplateCard(props) {
  const {
    title,
    description,
  } = props;

  const { editorHandler } = useContext(BryntumContext);
  const [isHovered, setIsHovered] = useState(false);

  const handleUseTemplate = async () => {
    try {
      // Generate a random number for the default test drive name
      const randomNumber = Math.floor(1000 + Math.random() * 9000);
      const defaultName = `${title} ${randomNumber}`;

      const result = await MessageDialog.prompt({
        title: "Personalize your Test Drive",
        message: "Enter a custom name for your Test Drive",
        textField: { value: defaultName },
        okButton: { text: "Create Test Drive" }
      });

      if (result.button === MessageDialog.okButton) {
        const { data } = await getDemoBoardsList();
        if (data.length) {
          const demoBoard = data[0];
          // Show user feedback dialog with 'Don't show again' option
          const showDialog = shouldShowAsyncDialog('DEMO_BOARD_CREATION');
          showDialog && editorHandler.openEditor(EDITOR_KEYS.asyncTaskMessageEditor, null, {record: "DEMO_BOARD_CREATION"}, { useExisting: true, by: "recordType" });
          await duplicateBoardAndTestDrive(demoBoard.id, result.text, ['everything'], { test_drive: true });
          showToast({ msg: "Test Drive created successfully!", type: "success" });
        }
      }
    } catch (error) {
      showToast({ msg: error?.response?.data || serverErrorMsg(), type: "error" });
    }
  };

  return (
    <TooltipProvider>
      <Card
        className={`transition-all duration-300 ease-in-out h-full hover:scale-[1.02] bg-card ${
          isHovered
            ? "shadow-lg"
            : "shadow-sm"
        }`}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <CardContent className="!p-swivu-base">
          {/* Header */}
          <div className="flex justify-between">
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-4 mb-swivu-base">
                <h3 className="text-lg font-semibold overflow-hidden text-ellipsis whitespace-nowrap text-foreground">
                  {title}
                </h3>
              </div>

              {/* Description */}
              <p dangerouslySetInnerHTML={{ __html: description }} className="text-swivu-sm text-muted-foreground mt-0 mb-swivu-base"></p>
            </div>
          </div>

          {/* Template Image */}
          <div className="mb-4 rounded-lg overflow-hidden bg-muted flex items-center justify-center">
            <img
              src="/assets/cucumber-construction.png"
              alt="Template Preview"
              className="aspect-video"
            />
          </div>

          {/* Button */}
          <Button
            size="sm"
            className="w-full bg-purple-600 hover:bg-purple-700 text-white border-purple-500"
            onClick={handleUseTemplate}
          >
            <i className="fa-solid fa-wand-magic-sparkles mr-2"></i>
            Use Template
          </Button>
        </CardContent>
      </Card>
    </TooltipProvider>
  );
}
